import { createSlice } from "@reduxjs/toolkit";
import {
  fetchDebtInformations,
  addDebtInformation,
  updateDebtInformation,
  deleteDebtInformation,
} from "./debtInformationsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const debtInformationsSlice = createSlice({
  name: "debtInformations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchDebtInformations.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchDebtInformations.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload || [];
    });
    builder.addCase(fetchDebtInformations.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(addDebtInformation.fulfilled, (state, action) => {
      state.items.push(action.payload);
    });
    builder.addCase(updateDebtInformation.fulfilled, (state, action) => {
      const idx = state.items.findIndex(item => item.id === action.payload.id);
      if (idx !== -1) {
        state.items[idx] = action.payload;
      }
    });
    builder.addCase(deleteDebtInformation.fulfilled, (state, action) => {
      state.items = state.items.filter(item => item.id !== action.payload);
    });
  },
});

export default debtInformationsSlice.reducer;
